import { withStyles } from '@material-ui/core/styles'
import AccordionActions from '@material-ui/core/AccordionActions'

const CustomExpansionPanelActions = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '8px 24px'
  },
  spacing: {
    marginLeft: 0
  }
})(AccordionActions)

export const DarkCustomExpansionPanelActions = withStyles({
  root: {
    backgroundColor: '#DEDCD9'
  }
})(CustomExpansionPanelActions)

export default CustomExpansionPanelActions
